import React from "react";
import { Helmet } from "react-helmet";
import Layout from "../components/common/layout/Index";
import useTranslationHook from "../components/hooks/useTranslationHook";
import { useTheme } from "../context/ThemeContext";
function Support() {
    const { t } = useTranslationHook();
    const { assets } = useTheme();
    return (
        <>
            <Helmet>
                <meta
                    name="keywords"
                    content={t(
                        "Bidhome-Adres, CRE, brokers, investment, commercial real estate, sales, auction"
                    )}
                />
                <meta
                    name="description"
                    content={t(
                        "Bidhome-Adres brings buyers, sellers, and brokers together to efficiently market and close commercial real estate deals in online CRE auctions."
                    )}
                />
                <title>{t("Propify - Support")}</title>
            </Helmet>
            <Layout>
                <div className="support-wrap">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-6">
                                <p className="text-center">
                                    <img
                                        src={assets.contactIcon}
                                        alt="Contact Icon"
                                    />
                                </p>
                                <h5>
                                    {t(
                                        "Anything on your mind? Just reach out!"
                                    )}
                                </h5>
                                <p className="text">
                                    {t(
                                        "our support team is available 9am - 6pm Sunday to Saturday."
                                    )}
                                </p>
                                <ul>
                                    {/* <li>
                                        <div className="icon">
                                            <img
                                                src="/img/headphone-icon.svg"
                                                alt="Contact Icon"
                                            />
                                        </div>
                                         +971555254321
                                    </li> */}
                                    <li>
                                        <div class="icon">
                                            <img
                                                src="/img/envelope-icon.svg"
                                                alt="Contact Icon"
                                            />
                                        </div>
                                        support@propify.ae
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    );
}
export default Support;
